import BoardingPassDesk from './components/BoardingPassDesk.css';

export default {
	BoardingPassDesk
};
